import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { ErrorBoundary } from "./ErrorBoundary";

/**
 * Route-scoped error boundary: a crashing page shows a recovery panel while
 * the surrounding shell (sidebar, top bar, report tracker) keeps working,
 * and navigating to another route automatically resets the boundary.
 */
export function RouteErrorBoundary({ children }: { children: ReactNode }) {
  // location.key changes on EVERY navigation (including same-path search/hash
  // changes and re-clicking the current nav item), unlike pathname.
  const { key } = useLocation();
  return <ErrorBoundary resetKey={key}>{children}</ErrorBoundary>;
}
